import React, { createContext, ReactNode } from 'react';

// Cart feature removed. 
export const CartContext = createContext<any>(undefined);

interface CartProviderProps {
  children: ReactNode;
}

export const CartProvider: React.FC<CartProviderProps> = ({ children }) => {
  return <>{children}</>;
};